import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBackgroundTaskStatus } from '../../enums/admin-background-task-status';

@jsonObject
export class AdminBackgroundTaskStatusResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: AdminBackgroundTaskStatus;

  @jsonMember(Number)
  public readonly progress!: number;

  @jsonMember(String)
  public readonly taskData?: Nillable<string>;
}
